import { Directive, ElementRef, Input, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[truncateToTwoLines]',
})
export class TruncateToTwoLinesDirective implements AfterViewInit, OnDestroy {
  @Input('truncateToTwoLines') originalText: string = '';
  @Input() suffix: string = '...';

  private resizeObserver!: ResizeObserver;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    if (!this.originalText) {
      this.originalText = this.el.nativeElement.innerText || '';
    }

    this.applyTruncation();

    // Recalculate on resize
    this.resizeObserver = new ResizeObserver(() => this.applyTruncation());
    this.resizeObserver.observe(this.el.nativeElement);
  }

  private applyTruncation() {
    const element = this.el.nativeElement;
    const style = window.getComputedStyle(element);
    const lineHeight = parseFloat(style.lineHeight);

    // Create an invisible span to measure text
    const tempSpan = this.renderer.createElement('span');
    this.renderer.setStyle(tempSpan, 'visibility', 'hidden');
    this.renderer.setStyle(tempSpan, 'white-space', 'normal');
    this.renderer.setStyle(tempSpan, 'position', 'absolute');
    this.renderer.setStyle(tempSpan, 'width', style.width);
    this.renderer.setStyle(tempSpan, 'font', style.font);
    this.renderer.setProperty(tempSpan, 'innerText', this.originalText);
    this.renderer.appendChild(document.body, tempSpan);

    // Calculate max allowed height (2 lines)
    const maxHeight = lineHeight * 2;

    let text = this.originalText;
    let truncated = false;

    // Keep removing words until fits 2 lines
    while (tempSpan.scrollHeight > maxHeight && text.includes(' ')) {
      truncated = true;
      text = text.split(' ').slice(0, -1).join(' ');
      tempSpan.innerText = text + this.suffix;
    }

    // Apply the truncated text
    this.renderer.setProperty(element, 'innerText', truncated ? text + this.suffix : this.originalText);

    // Clean up
    this.renderer.removeChild(document.body, tempSpan);
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
